const configuration = {
  apiUrl: process.env.REACT_APP_API_URL,
  sections: [],
  drawsListsTypes: [],
}

export default configuration
